import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import moment from 'moment';
import Loader from '../../../components/ui/Loader/Loader';
import axios from 'axios';
import AnimatedMap from '../../reports/iot/gpsReports/AnimatedMap';

const TripSessionDetail = (props) => {
    const [loading, setLoading] = useState(false);
    const [tripData, setTripData] = useState([]);
    const [selectedTrip, setSelectedTrip] = useState(null);

    const mapRef = useRef(null);

    useEffect(() => {
        if (props?.assetDetail?.iot_device_imei && props?.shiftDetail) {
            fetchTripData();
        }
    }, [props?.shiftDetail]);

    const fetchTripData = () => {
        setLoading(true);
        const shift = props?.shiftDetail?.shift;
        const startMoment = moment(
            `${shift?.shift_date} ${shift?.shift_start_his}`,
            "YYYY-MM-DD HH:mm:ss"
        );
        const endMoment = moment(startMoment).add(shift?.seconds, 'seconds');

        const now = moment();
        const finalEndMoment = endMoment.isAfter(now) ? now : endMoment;

        const requestBody = {
            imeIs: [props?.assetDetail?.iot_device_imei],
            startDate: startMoment.toISOString(),
            endDate: finalEndMoment.toISOString()
        };

        axios.post(`https://api6.tappetbox.in/api/Report/trip-session?closeOpenAtEnd=false`, requestBody)
            .then(response => {
                setTripData(response.data || []);
            })
            .catch(error => {
                console.error("Error fetching device data:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleViewMap = (trip) => {
        setSelectedTrip(trip);
        setTimeout(() => {
            if (mapRef.current) {
                const points = [];
                if (trip.startLat && trip.startLong) {
                    points.push({ 
                        lat: trip.startLat, 
                        lng: trip.startLong 
                    });
                }
                if (trip.stopLat && trip.stopLong) {
                    points.push({ 
                        lat: trip.stopLat, 
                        lng: trip.stopLong 
                    });
                }
                
                mapRef.current.openMap({
                    data: points.map(p => ({
                        latitude: p.lat,
                        longitude: p.lng
                    }))
                });
            }
        }, 100);
    };

    const handleCloseMap = () => {
        setSelectedTrip(null);
    };

    const renderTripData = () => {
        const trips = tripData;

        return (
            <div className="row">
                <div className="col-12">
                    <div className="tab_content_wrapper fw-bold mb-3">
                        Trip Details
                    </div>
                    {props?.shiftDetailLoading ? <Loader /> :
                        <table className="table table-bordered mb-0 table-hover mt-2">
                            <thead className="table-light">
                                <tr className='text-center'>
                                    <th style={{ width: "5%" }}>#</th>
                                    <th style={{ width: "13%" }}>Start Time</th>
                                    <th style={{ width: "13%" }}>Stop Time</th>
                                    <th style={{ width: "10%" }}>Total Duration</th>
                                    <th style={{ width: "10%" }}>Total KM Running</th>
                                    <th style={{ width: "10%" }}>View </th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? 
                                    <tr><td className='text-center' colSpan={6}><Loader /></td></tr> :
                                    trips.length > 0 ?
                                        trips.map((trip, tripIndex) => (
                                            <tr key={tripIndex} className='text-center'>
                                                <td>Trip {tripIndex + 1}</td>
                                                <td>
                                                    {trip?.startTimestamp ?
                                                        moment(trip.actualStartTimestamp).format('DD-MMM-YYYY HH:mm')
                                                        : 'N/A'
                                                    }
                                                </td>
                                                <td>
                                                    {trip?.stopTimestamp ?
                                                        moment(trip.actualStopTimestamp).format('DD-MMM-YYYY HH:mm')
                                                        : 'N/A'
                                                    }
                                                </td>
                                                <td><strong>{trip?.totalDuration || 'N/A'}</strong></td>
                                                <td>
                                                    <strong>
                                                        {trip?.totalKmRunning ? `${trip.totalKmRunning} km` : 'N/A'}
                                                    </strong>
                                                </td>
                                                <td className="text-primary cursor_pointer" onClick={() => handleViewMap(trip)}>
                                                    View Map
                                                </td>
                                            </tr>
                                        ))
                                        : <tr><td className='text-center' colSpan={6}>No Record Found</td></tr>
                                }
                            </tbody>
                        </table>
                    }
                </div>
            </div>
        );
    };

    return (
        <>
            <Helmet><title>Trip Data</title></Helmet>
            <div className="row pl2">
                <div className="bg-white p-3">
                    {renderTripData()}
                </div>
            </div>
            
            <AnimatedMap
                ref={mapRef}
                onClose={handleCloseMap}
            />
        </>
    );
};

export default TripSessionDetail;